import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import MainMenu from "./MainMenu";
import PersonalInfo from "./PersonalInfo";

const Layout = () => {
  return (
    <div className="page-wrapper home-3">
      <Header />

      <div className="container z-index-3">
        <div className="row">
          <PersonalInfo />
          <div className="col-xxl-8 col-xl-8 col-lg-8">
            <MainMenu />
            <Outlet />
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
